<template>
    <div>
        <MdTitleRegInfo  
            v-bind:RegistrationInfo="{}"  
            v-bind:titlePrefix="this.$attrs.editMode  ? 'Edit User' :'Add User'"            
            v-bind:titleRef="'titleElementUsers'">
        </MdTitleRegInfo>

        <p class="iSetupLabel">
            <i class="ikon med-help"></i>
            Fill out the form with as much user information as possible. When finished, click <b>Save</b> to continue.
        </p>   
        
        <b-row class="mt-3">
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="'User NPI'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="false"
                    v-bind:MaxLengthProp="15" 
                    v-bind:Name="'npi'"
                    v-model="User.npi"                 
                    v-bind:Id="'inpi'"/>        
            </b-col>
                 <b-col lg="9" md="9" sm="12">
            <p class="text-muted mt-4">Indicate your National Provider Identifier (NPI).
            </p>
          </b-col> 
      
         <b-col lg="3" md="3" sm="12" class="customCol">  
             <MdButton
                v-bind:isReadOnly="false"
                v-bind:Label="'Get User Information By NPI'"
                v-bind:Name="'btngetInfoNPI'"
                v-on:click="getInfoNpi()"
                v-bind:ClassProp="'btn-login'"/>            
         </b-col>
        </b-row>
        <MdTitle v-bind:Text="'General Information'"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>  
        <b-row>
            <b-col lg="3" md="3" sm="12">
               <MdEdit 
                  v-bind:Label="'First Name *'"
                  v-bind:TypeProp="'text'"
                  v-bind:MaxLengthProp="64" 
                  v-bind:isRequired="true"
                  v-bind:isValid="isFirstNameValid"
                  v-bind:Name="'FirstName'"
                  v-model="User.firstName"               
                  v-bind:Id="'iFirstName'"/> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
               <MdEdit 
                  v-bind:Label="'Last Name *'"
                  v-bind:TypeProp="'text'"
                  v-bind:MaxLengthProp="64" 
                  v-bind:isRequired="true"
                  v-bind:isValid="isLastNameValid"
                  v-bind:Name="'LastName'"
                  v-model="User.lastName"               
                  v-bind:Id="'iLastName'"/> 
            </b-col>
             <b-col lg="3" md="3" sm="12">
                <MdEdit 
                  v-bind:Label="$t('Shared.Email')+' *'"
                  v-bind:TypeProp="'email'"
                  v-bind:MaxLengthProp="75" 
                v-bind:isRequired="true"
                  v-bind:isValid="isEmailValid"
                  v-bind:Name="'email'"
                  v-model="User.email"                 
                  v-bind:Id="'iEmail'"/>     
               </b-col>             
             <b-col lg="3" md="3" sm="12">
               <MdEdit 
                  v-bind:Label="'Cell Phone'"
                  v-bind:TypeProp="'text'"
                  v-bind:MaxLengthProp="255" 
                  v-bind:Name="'CellPhone'"
                  v-model="User.cellPhone"               
                  v-bind:Id="'iCellPhone'"/> 
            </b-col>            
        </b-row>

        <div v-if="ProviderList.length > 1">
            <MdTitle v-bind:Text="'Companies'" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
             <p class="ml-2">{{$t('treatmentplan.Text1')}}</p>
            <b-row class="mt-3">
            <b-col md="3">
               <MdCheckBox
                  v-bind:Label="'Select All'"
                  v-bind:Name="'checkbox-selectAll'"
                  v-bind:ClassProp="'AlignCheck'"
                  v-bind:CheckedValue="true"
                  v-bind:UncheckedValue="false"
                  v-on:change="onChangeSelectAll"
                  v-model="SelectAllProvider"                 
               />
            </b-col>
        </b-row>
            <b-row>
                <b-col lg="12" md="12" sm="12">
                    <MdCheckListBox2 
                        v-model="ProvidersModel"
                        v-bind:OnChangeProp="ChangeProvider"
                        v-bind:Options="ProviderList"
                        v-bind:Height="'65px'"
                        v-bind:columnCount="5"                        
                        :textField="'company'"
                        :valueField="'code'"/> 
                </b-col>
            <!--<b-col lg="6" md="6" sm="12">
                    <div class="col-md-12 text-muted px-4 mt-3">
                        <p>{{$t('treatmentplan.Text1')}}</p>
                        <p>{{$t('treatmentplan.Text2')}}</p>
                        <p>{{$t('treatmentplan.Text3')}}</p>                                        
                    </div>
                </b-col> -->           
            </b-row>
        </div>       

        <MdTitle v-bind:Text="'Roles *'" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
         <p class="text-muted mt-4">Choose the user’s role based on the features they need. Roles define what the user can access in the system.</p>
        <b-row class="mt-3">
            <b-col lg="12" md="12" sm="12">                 
                    <RadioGroup 
                        v-model="RoleModel"
                        v-bind:Options="RoleList"
                        v-bind:LabelProp="''"
                        v-bind:isRequired="true"
                        v-bind:Id="'iRoleRadio'"
                        v-bind:Name="'iRoleRadio'"
                        v-bind:OnChangeProp="ChangeDropDownEmployeeRole"
                        v-bind:columnCount="3"
                        v-bind:isValid="isValidRole"
                        :textField="'description'"
                        :valueField="'code'"/> 
            </b-col>                   
        </b-row>    
        
         <MdTitle v-bind:Text="'Employee Type *'" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
         <p class="text-muted mt-4">Choose the type of employee based on their role in your organization.</p>
         <b-row class="mt-3">
            <b-col lg="12" md="12" sm="12">
                    <RadioGroup 
                        v-model="EmployeeTypeModel"
                        v-bind:Options="EmployeeTypeList"
                        v-bind:LabelProp="''"
                        v-bind:isRequired="true"
                        v-bind:OnChangeProp="OnChangeEmployeeType"
                        v-bind:columnCount="3"
                        v-bind:isValid="isValidEmpType"
                        v-bind:Id="'iEmployeeTypeRadio'"
                        v-bind:Name="'iEmployeeTypeRadio'"
                        :textField="'description'"
                        :valueField="'code'"/> 
            </b-col>                   
        </b-row>

        <div id="additionalInfo">
        <MdTitle v-bind:Text="'Additional Information'" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
            <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                        v-bind:Label="'Credential'"
                        v-bind:Options="CredentialList"
                        v-bind:FieldDescription="'description'"
                        v-bind:FieldCode="'code'"
                        v-bind:IsDisabled="false"
                        v-bind:Model="User.credential"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownCredential"/>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdEdit 
                    v-bind:Label="'License'"
                    v-bind:TypeProp="'text'"
                    v-bind:MaxLengthProp="15" 
                    v-bind:isReadOnly="false"
                    v-bind:Name="'License'"
                    v-model="User.licenseNumber"                 
                    v-bind:Id="'iLicense'"/> 
                </b-col>      
                <b-col lg="3" md="3" sm="12">                   
                    <MdEdit 
                        v-bind:Label="'License State'"
                        v-bind:TypeProp="'text'"
                        v-bind:MaxLengthProp="2" 
                        v-bind:Autocomplete="true"                           
                        v-bind:isReadOnly="false"
                        v-bind:Name="'iLicenseState'"
                        v-model="User.licenseState"                 
                        v-bind:Id="'iLicenseState'"/> 
                </b-col> 
                <b-col lg="3" md="3" sm="12"> 
                        <MdLookup 
                            v-bind:ModelCode="User.taxonomyCode"
                            v-bind:ModelDescription="iTaxonomyDescrip"
                            v-bind:Label="'Taxonomy'"
                            v-bind:RefCode="'Taxonomy'"   
                            v-bind:Api="'DoctorSpecialties'"
                            v-bind:FieldCode="'code'"
                            v-bind:IsDisabled="false"
                            v-bind:FieldDescription="'description'"                          
                            :SearchTitle="$t('Shared.Taxonomy')"
                            :GetValues="onCodeConditionOk"
                            :InvalidFeedback="$t('ModalCategory.fBakInvCatMsg')"
                            :SearchFieldCode="'Code'"/>
                 </b-col>
            </b-row>

            <b-row>               
                <b-col lg="3" md="3" sm="12">
                   <MdEdit 
                        v-bind:Label="'Dea'"
                        v-bind:TypeProp="'text'"
                        v-bind:MaxLengthProp="9" 
                        v-bind:Autocomplete="true"                           
                        v-bind:isReadOnly="false"
                        v-bind:Name="'idea'"
                        v-model="User.dea"                 
                        v-bind:Id="'idea'"/> 
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                        v-bind:Label="'Cosigner in Notes'"
                        v-bind:Options="CosignerList"
                        v-bind:FieldDescription="'text'"
                        v-bind:FieldCode="'value'"
                        v-bind:IsDisabled="false"
                        v-bind:Model="CosignerModel"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownCosigner"/>
                </b-col>               
                 <b-col lg="3" md="3" sm="12">
                    <MdSelect
                        v-bind:Label="'Require Calendar for Scheduling'"
                        v-bind:Options="RequireCalendarList"
                        v-bind:FieldDescription="'text'"
                        v-bind:IsDisabled="false"
                        v-bind:FieldCode="'code'"
                        v-bind:Model="User.isCalendarResource"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownRequireCalendar"/>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                        v-bind:Label="'ePrescribing User Type'"
                        v-bind:Options="NewCropUserTypeList"
                        v-bind:FieldDescription="'description'"
                        v-bind:IsDisabled="false"
                        v-bind:FieldCode="'code'"
                        v-bind:Model="User.type"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownNewCrop"/>
                </b-col>        
            </b-row>
        </div>


         <MdTitle v-bind:Text="'Employee Signature'" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

       <MdSignature              
            v-bind:Data64="this.Image" 
            v-bind:Id="'iEmployeeSignature'" 
            v-bind:Title="'Employee Signature'"
            v-bind:VisibleSigPad="true" 
            v-bind:VisibleLoadImage="false">
        </MdSignature> 

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnIUserBack'"               
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="GotoIUserList"/>  

            <MdButton
                v-bind:isReadOnly="false"
                v-bind:Label="$t('Shared.Save')"
                v-on:click="SaveUser"
                v-bind:Name="'btnUsers'"
                v-bind:ClassProp="'mx-2 btn-login'"/>
        </div>



    </div>
   

</template>

<script> 
import DBFunctions from '@/common/DBFunctions.js';
import GlobalService from '@/services/global.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import EnumService from "@/services/enum.service";
import EmployeeTypeService from '@/services/employeetypes.service'
import UsersService from '@/services/users.service'
import EmployeeCredentialService from '@/services/employeecredential.service'
import ProviderService from '@/services/provider.service' 
import Utils from "@/common/utils";
import ISetup from '@/services/isetup.service'
import { EventBus } from '@/event-bus.js';
// v-bind:DataList="dataList"
export default {
  name: 'IniUsers',
  mixins: [ShowMessage, DBFunctions],
  data(){
    return{
        Image:"",
        SelectAllProvider:false,
        isFirstNameValid:true,
        isLastNameValid:true,
        isEmailValid:true,
        EmployeeTypeModel:"",
        RoleModel:"",
        isValidEmpType:true,
        isValidRole:true,
        RoleFullDescription:"",
        EmployeeFullDescription:"",
        ProvidersModel:[],      
        ProviderList:[],
        NewCropUserTypeList:[],
        CosignerModel:{value:null,text:"Not Applicable"},
        CosignerList:[{value:false,text:"Is Cosigner"},{value:true,text:"Need Cosigner"},{value:null,text:"Not Applicable"}],
        ReadOnly:true,
        VisibleAdditional:false,
        EmployeeTypeList:[],

        CredentialList:[],
        IsCosignerList:EnumService.YesNoOptions,
        RequireCalendarList:[{code:true,text:"Yes"},{code:false,text:"No"}],
       
        TaxonomyList:[],
        StateList:[],
        RoleList:[],
        iTaxonomyDescrip:"",
        User:{
            firstName:"",
            lastName:"",
            employeeType:"",
            cellPhone:"",
            email:"",
            role:"",
            credential:"",
            npi:"",
            dea:"",
            taxonomyCode:"",           
            licenseNumber:"",
            licenseState:"",
            isCalendarResource:false            
        },
        dataList:[
			'Alabama',
			'Alaska',
			'American Samoa',
			'Arizona',
			'Arkansas',
			'California',
			'Colorado',
			'Connecticut',
			'Delaware',
			'District of Columbia',
			'Florida',
			'Georgia',
			'Guam',
			'Hawaii',
			'Idaho',
			'Illinois',
			'Indiana',
			'Iowa',
			'Kansas',
			'Kentucky',
			'Louisiana',
			'Maine',
			'Maryland',
			'Massachusetts',
			'Michigan',
			'Minnesota',
			'Mississippi',
			'Missouri',
			'Montana',
			'Nebraska',
			'Nevada',
			'New Hampshire',
			'New Jersey',
			'New Mexico',
			'New York',
			'North Carolina',
			'North Dakota',
			'Northern Mariana Islands',
			'Ohio',
			'Oklahoma',
			'Oregon',
			'Pennsylvania',
			'Puerto Rico',
			'Rhode Island',
			'South Carolina',
			'South Dakota',
			'Tennessee',
			'Texas',
			'Trust Territories',
			'Utah',
			'Vermont',
			'Virgin Islands',
			'Virginia',
			'Washington',
			'West Virginia',
			'Wisconsin',
			'Wyoming'			
			]
    }
  },
  methods:{

   ChangeDropDownNewCrop(){

   },

    onChangeSelectAll(item){
        let arrselected = [];
        if(item){
            this.ProviderList.forEach(element => {
                arrselected.push(element.code);
            });
            this.ProvidersModel = arrselected;
        }else{
            this.ProvidersModel = [];
        }        
    },

     ChangeProvider(){
        if(this.ProvidersModel.length === this.ProviderList.length){
            this.SelectAllProvider = true;
        }else{
            this.SelectAllProvider = false;
        }
    },

    async getInfoNpi(){   
        this.$emit('load', true);  
       await ISetup.getInfoByNPIUser(this.User.npi)
      .then((response) => {      
           if (response.status == "200") {
               let data = response.data;
               this.User.firstName = data.firstName;
               this.User.lastName = data.lastName;
               this.User.cellPhone = data.cellPhone;
               this.User.dea = data.dea;
               this.User.licenseNumber = data.licenseNumber;
               this.User.licenseState = data.licenseState;
               this.User.taxonomyCode = data.taxonomyCode;
               this.iTaxonomyDescrip = data.taxonomyDescription;
           }
           this.$emit('load', false); 
      })
      .catch(error => {
        this.$emit('load', false); 
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },

    OnChangeEmployeeType(item){ 
        
       /* if(item !== undefined && item !== null){
            if(item === 'T' || item === 'M' || item === 'N'){
                this.User.isCalendarResource = false;
                this.ReadOnly = false;
            }else{
                this.ReadOnly = true;
            }
        }else{
              this.ReadOnly = true;
        }   */ 
       
        this.isValidEmpType = item ? true : false;
       
       for(var i = 0; i < this.EmployeeTypeList.length; i++){
        if(this.EmployeeTypeList[i].code === item){
            this.EmployeeFullDescription = this.EmployeeTypeList[i].fullDescription;
            break;
        }
       }       
    },  
    
    ChangeDropDownEmployeeRole(item){
        for(var i = 0; i < this.RoleList.length; i++){
        if(this.RoleList[i].code === item){
            this.RoleFullDescription = this.RoleList[i].fullDescription;
            break;
        }
       }         
        this.isValidRole = item ? true : false;       
    },

    validate_required() {
        this.isFirstNameValid = this.User.firstName ? true : false;
        this.isLastNameValid = this.User.lastName ? true : false;      
        this.isEmailValid = this.User.email && Utils.ValidateEmail(this.User.email) ? true : false; 
        
        this.isValidRole = this.RoleModel ? true : false;
        this.isValidEmpType = this.EmployeeTypeModel ? true : false;
        
        return this.isFirstNameValid  && this.isLastNameValid && this.isEmailValid && this.isValidRole && this.isValidEmpType;
      },

    SaveUser(){
        if(this.validate_required()){
            this.$attrs.editMode ? this.Update() : this.Add();
        }else{
            this.$emit('load', false);
            //elemSaveBtn.removeAttribute("disabled");
            this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");
        }
        
    },

    Add() { 
        let data = {
            FirstName:this.User.firstName,
            LastName:this.User.lastName,
            EmployeeTypeCode:this.EmployeeTypeModel,
            RoleCode:this.RoleModel,
            CellPhone:this.User.cellPhone,
            Email:this.User.email,
            CredentialsCode:this.User.credential,
            ProviderCodeList:this.ProvidersModel,
            Npi:this.User.npi,
            TaxonomyCode:this.User.taxonomyCode,
            LicenseNumber:this.User.licenseNumber,
            LicenseState:this.User.licenseState,
            NeedCosigner:this.CosignerModel ? this.CosignerModel.value : null,
            IsCalendarResource:this.User.isCalendarResource,
            EmployeeSignature:this.Image,
        } 
        this.$emit('load', true);         
      ISetup.AddUser(data)
        .then((response) => {
          if (response.status == '200') {
                this.pendingChanges = false;  
                this.$emit('load', false);
                this.$router.push({name: "iusers"});
                 setTimeout(() => 
                        this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                        , 50);
                               
          }
        })
        .catch((error) => {
          this.$emit('load', false);
          // elemSaveBtn.removeAttribute("disabled"); 
            this.showResponseErrorMessage(error);
        });
    },

    Update() { 
        let data = {
            FirstName:this.User.firstName,
            LastName:this.User.lastName,
            EmployeeTypeCode:this.EmployeeTypeModel,
            RoleCode:this.RoleModel,
            CellPhone:this.User.cellPhone,
            Email:this.User.email,
            CredentialsCode:this.User.credential,
            ProviderCodeList:this.ProvidersModel,
            Npi:this.User.npi,
            TaxonomyCode:this.User.taxonomyCode,
            LicenseNumber:this.User.licenseNumber,
            LicenseState:this.User.licenseState,
            NeedCosigner:this.CosignerModel ? this.CosignerModel.value : null,
            IsCalendarResource:this.User.isCalendarResource,
            EmployeeSignature:this.Image,
        } 
        this.$emit('load', true);         
      ISetup.UpdateUser(this.$route.params.id,data)
        .then((response) => {
          if (response.status == '200') {
                this.pendingChanges = false;  
                this.$emit('load', false);
                this.$router.push({name: "iusers"});
                 setTimeout(() => 
                        this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                        , 50);
                               
          }
        })
        .catch((error) => {
          this.$emit('load', false);
          // elemSaveBtn.removeAttribute("disabled"); 
            this.showResponseErrorMessage(error);
        });
    },
   

    onCodeConditionOk(result){
         var type = result.FieldName;
            if (type.indexOf('Taxonomy') >= 0) {               
                this.iTaxonomyDescrip = result.description;
                this.User.taxonomyCode = result.code;
            } 
    },
    ChangeDropDownEmployeeType(){      
        
    },

    GotoIUserList(){
        this.$router.push({ name:'iusers'});
    },

    ChangeDropDownCredential(item){
        this.User.credential = item ? item.code : null;
    },
    
    ChangeDropDownCosigner(item){
        this.CosignerModel = item ? item : null;
    },
    ChangeDropDownState(){

    },
    ChangeDropDownRequireCosigner(){

    },
    ChangeDropDownRequireCalendar(item){      
        this.User.isCalendarResource = item ? item.code : false;
    },

    ChangeDropDownTaxonomy(){

    },

     async getRols(){
       await UsersService.getRols()
            .then((response) => {      
               if (response.status == '200' && response.data) {              
                  this.RoleList = response.data;
               }  
         })
         .catch(error => {     
           this.showResponseErrorMessage(error);
         });    
    },

    async getNewCropUserTypeRols(){
       await GlobalService.getNewCropUserTypes()
            .then((response) => {      
               if (response.status == '200' && response.data) {              
                  this.NewCropUserTypeList = response.data;
               }  
         })
         .catch(error => {     
           this.showResponseErrorMessage(error);
         });    
    },

    async getUserById(){
        if(this.$attrs.editMode && this.$route.params.id) {
            this.$emit('load', true);
        await ISetup.GetUser(this.$route.params.id)
            .then((response) => {
               if(response.status == '200' && response.data){
                this.User = response.data; 
                this.EmployeeTypeModel = this.User.employeeTypeCode;
                this.RoleModel = this.User.roleCode;

                this.Image = this.User.employeeSignature;
                EventBus.$emit('onGetImage', this.Image); 

                this.ProvidersModel = this.User.providerCodeList;
                if(this.User.needCosigner === null){                   
                    this.CosignerModel.value = null;
                    this.CosignerModel.text = "Not Applicable";
                }else if(this.User.needCosigner){
                    this.CosignerModel.value = true;
                    this.CosignerModel.text = "Need Cosigner";
                    
                }else{
                    this.CosignerModel.value = false;
                    this.CosignerModel.text = "Is Cosigner";
                }


                this.iTaxonomyDescrip = this.User.taxonomyDescription;
               /* this.User.credential = {
                    code:"",
                    description:""
                }*/
                
                this.User.credential = this.User.credentialsCode;
               // this.User.credential.description = this.User.credentialsDescription;

               /* this.User.requireCalendar = {
                   code:false,
                   text:"" 
                }

                if(this.User.isCalendarResource === null || !this.User.isCalendarResource){
                    this.User.requireCalendar.code = false;
                    this.User.requireCalendar.text = 'No'; 
                }else{
                    this.User.requireCalendar.code = true;
                    this.User.requireCalendar.text = "Yes";    
                }*/

                /*if(this.EmployeeTypeModel === 'T' || this.EmployeeTypeModel === 'M' || this.EmployeeTypeModel === 'N'){
                    this.ReadOnly = false;
                    this.$set(this.User, 'isCalendarResource', this.User.isCalendarResource);
                }else{
                    this.ReadOnly = true;
                    this.$set(this.User, 'isCalendarResource', this.User.isCalendarResource);
                }*/

               // this.$set(this.User, 'isCalendarResource', this.User.isCalendarResource);
               if(this.ProvidersModel.length === this.ProviderList.length){
                    this.SelectAllProvider = true;
               }else{
                    this.SelectAllProvider = false;
               }


                this.$emit('load', false);               
               }
                this.$emit('load', false);
            })
            .catch((error) => {   
                this.$emit('load', false);           
                this.showResponseErrorMessage(error);
               });
         }
      },

       getLicenseState(){
            let param = { CodeType:"USStates" };
             GlobalService.getGlobalCustom(param)
              .then((response) => {
                if(response.status == '200' && response.data.length > 0){                          
                  this.StateList = response.data;
                }                             
              })
              .catch((error) => {                
                this.showResponseErrorMessage(error);
              }); 
          },  

    getEmployeeCredential(){       
      this.parameter.PageNumber = null;           
      this.parameter.PageSize = null;      
      EmployeeCredentialService.getAll(this.parameter)
        .then((response) => {
            if(response.status == '200' && response.data){
              this.CredentialList = response.data; 
              }               
        })
        .catch((error) => {  
            this.$emit('load', false);       
            this.showResponseErrorMessage(error);     
        }); 
    },

     getEmployeeTypes() {
            const param = {
                Active: true
            }
            this.EmployeeTypeList = [];
            EmployeeTypeService.getAllEmployeeType(param)
                .then(response => {
                    if (response.status == "200" && response.data) {
                        const data = response.data;
                        data.forEach(element => {
                            this.EmployeeTypeList.push({
                                code: element.code,
                                description: element.description,
                                fullDescription:element.fullDescription
                            })
                        });
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

    getProviders(){    
      ProviderService.getFullProvidersNoTraining()
      .then((response) => {      
           if (response.status == "200") {
                this.ProviderList = response.data;
           }
      })
      .catch(error => {
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },
  },

  async created(){
    this.getProviders();
    this.getEmployeeCredential();
    this.getEmployeeTypes();
    this.getLicenseState();  
    this.getNewCropUserTypeRols();
   await this.getRols();
   await this.getUserById();

     EventBus.$on("onMouseStop", function (image) { 
      this.Image = image ? image.split(",")[1] : "";      
     }.bind(this));
  },

  mounted(){
    
  },
  beforeDestroy () {     
    EventBus.$off('onMouseStop');    
  },   
};
</script>


